import { render, staticRenderFns } from "./SignUpSuccess.vue?vue&type=template&id=00f7474b"
import script from "./SignUpSuccess.vue?vue&type=script&lang=js"
export * from "./SignUpSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports